export default [{
  re: /Product line '(\d+)' not found\./,
  key: 'err.productline.not_found'
}, {
  re: /Duplicate IDs found in file: (.*)/,
  key: 'err.policynumber.duplicate_found'
}];


// WEBPACK FOOTER //
// ./src/messageTranslations.js